module.exports = __webpack_public_path__ + "img/sol_cap3.7721514f.png";